import { AiClient, SocialCaptionGenerationPayload } from 'api/clients/AiClient'
import { pipe } from 'lodash/fp'
import {
  removeBulletListPrefixes,
  removeNumberedListPrefixes,
  removeSurroundingQuotes,
  trim,
} from 'components/Wizards/sanitisers'

export const generateSocialCaptions = async ({
  payload,
  signal,
}: {
  payload: SocialCaptionGenerationPayload
  signal?: AbortSignal
}) => {
  const socialCaptionsResponse = await AiClient.generateSocialCaptions({ payload, signal })

  return socialCaptionsResponse.split(/\n/).map(sanitise).filter(Boolean)
}

const sanitise = (str: string) =>
  pipe(trim, removeNumberedListPrefixes, removeBulletListPrefixes, removeSurroundingQuotes)(str)
